import * as yup from 'yup';
import { CustomerType } from '../../AccountOpening.meta';
import {
  companyNameValidation,
  jobTitleValidation,
} from '../../fields/EmploymentStatus/EmploymentStatus.meta';

export const validation = yup.object().shape({
  primaryApplicant: yup.object().shape({
    employerName: companyNameValidation,
    positionEmployed: jobTitleValidation,
  }),

  secondApplicant: yup.object().when('$customerType', {
    is: CustomerType.Joint,
    then: yup.object().shape({
      employerName: companyNameValidation,
      positionEmployed: jobTitleValidation,
    }),
  }),
});
